import React from 'react';
import propTypes from 'prop-types';
import SideSection from 'tailwind-components/SideSection/SideSection';
import SideSectionUnnapointed from 'tailwind-components/SideSection/SideSectionUnnapointed';
import ByStateCarriersSidebar from './ByStateCarriersSidebar';
import SidebarContent from 'tailwind-components/ContentWithSidebar/SidebarContent';

export default function CarrierAppointmentsSidebarBody({
  showByStateCarrierList,
  mapStateCarrierNames,
  onMapStateCarrierClick,
  activeCarrier,
  isSomewhatAppointed,
  createAppointmentRequest,
  obFormCompleted,
  actionableOnly,
  mapSelectedStateCode,
  hasActiveFilters = false
}) {
  if (showByStateCarrierList) {
    return (
      <ByStateCarriersSidebar
        mapSelectedStateCode={mapSelectedStateCode}
        carrierNames={mapStateCarrierNames}
        onCarrierClick={onMapStateCarrierClick}
        hasActiveFilters={hasActiveFilters}
      />
    );
  }

  if (!activeCarrier?.name) {
    return null;
  }

  if (isSomewhatAppointed) {
    return (
      <SidebarContent includesHeader dataTour='carrier-appt-sidebar'>
        <SideSection
          {...activeCarrier}
          createAppointmentRequest={createAppointmentRequest}
          obFormCompleted={obFormCompleted}
          actionableOnly={actionableOnly}
        />
      </SidebarContent>
    );
  }

  return (
    <SidebarContent includesHeader dataTour='carrier-appt-sidebar'>
      <SideSectionUnnapointed
        {...activeCarrier}
        createAppointmentRequest={createAppointmentRequest}
        obFormCompleted={obFormCompleted}
      />
    </SidebarContent>
  );
}

CarrierAppointmentsSidebarBody.propTypes = {
  showByStateCarrierList: propTypes.bool.isRequired,
  mapStateCarrierNames: propTypes.arrayOf(propTypes.string),
  onMapStateCarrierClick: propTypes.func.isRequired,
  activeCarrier: propTypes.object,
  isSomewhatAppointed: propTypes.bool.isRequired,
  createAppointmentRequest: propTypes.func,
  obFormCompleted: propTypes.bool,
  actionableOnly: propTypes.bool,
  mapSelectedStateCode: propTypes.string,
  hasActiveFilters: propTypes.bool
};
